import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { DatePicker } from "../atoms/DatePicker";
import onDateEdit from "../util/forms/onDateEdit";
import dayjs from "dayjs";
import ILearn from "../molecules/ILearn";

class IrqClosingDateView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/Calendar.svg"
          />
          <div className="closing-date-row">
            <DatePicker
              value={
                this.props.data.plannedClosingDate || dayjs().add(30, "day")
              }
              reactComponent={this}
              name="plannedClosingDate"
              helperText={this.props.errors.plannedClosingDate}
              autoFocus
            />
          </div>
          <EditActions
            canSubmit={this.props.isValid}
            customSubmit={() => {
              if (!this.props.data.plannedClosingDate) {
                const dayjsDate = dayjs().add(31, "day");
                onDateEdit(dayjsDate, "plannedClosingDate", this);
              }
              this.props.navigationContext.goNext(
                this.props.navigationsAway.Primary,
                true
              );
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqClosingDateView));
